import React, { useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Box, Typography, Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import StepHighSchool from "./StepHighSchool";
import StepHigherSecondary from "./StepHigherSecondary";
import StepDiploma from "./StepDiploma";
import StepUndergraduate from "./StepUndergraduate";
import StepPostgraduate from "./StepPostgraduate";
import { useNavigate, useLocation } from "react-router-dom";

const steps = [
  "High School",
  "Higher Secondary",
  "Diploma",
  "Undergraduate",
  "Postgraduate",
];

const EducationStepper = () => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const [activeStep, setActiveStep] = useState(location.state?.activeStep ?? 0);


  useEffect(() => {
    if (location.state?.activeStep !== undefined) {
      setActiveStep(location.state.activeStep);
    }
  }, [location.state]);

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    } else {
      navigate('/candidate/address-info');
    }
  };

  const getStepComponent = () => {
    switch (activeStep) {
      case 0:
        return <StepHighSchool onNext={() => setActiveStep(1)} onBack={handleBack} />;
      case 1:
        return <StepHigherSecondary onNext={() => setActiveStep(2)} onBack={handleBack} />;
      case 2:
        return <StepDiploma onNext={() => setActiveStep(3)} onBack={handleBack} />;
      case 3:
        return <StepUndergraduate onNext={() => setActiveStep(4)} onBack={handleBack} />;
      case 4:
        return <StepPostgraduate onNext={() => setActiveStep(5)} onBack={handleBack} />;
      default:
        return (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            sx={{ mt: 5 }}
          >
            <CheckCircleOutlineIcon sx={{ fontSize: 60, color: "green" }} />
            <Typography variant="h6" sx={{ mt: 2, fontWeight: "bold" }}>
              All education steps completed!
            </Typography>
            <Typography variant="body1" color="textSecondary">
              Your details have been saved successfully.
            </Typography>
            <Box display="flex" gap={2} sx={{ mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/candidate/address-info")}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/candidate/employment-info")} // Points to your employment page
              >
                Save & Continue
              </Button>
            </Box>
          </Box>
        );
    }
  };

  return (
    <Box sx={{ width: "100%", padding: 4 }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <Box sx={{ mt: 2 }}>{getStepComponent()}</Box>
    </Box>
  );
};

export default EducationStepper;